package com.vizio.redwolf.dms.model

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable
import kotlin.js.JsExport

@Serializable
@JsExport
sealed class UnregisterAllResponse {
    @Serializable
    class Invalid(
        @SerialName("message") val message: String? = null,
        @SerialName("responseCode") val responseCode: String? = null
    ) : UnregisterAllResponse()

    @Serializable
    @SerialName("device_all_unregistered")
    class UnregistrationSuccess : UnregisterAllResponse() {
        val responseCode: String by lazy {
            @OptIn(kotlinx.serialization.ExperimentalSerializationApi::class)
            serializer().descriptor.serialName
        }
    }

    @Serializable
    @SerialName("no_devices_to_unregister")
    class NoDevicesToUnregister : UnregisterAllResponse() {
        val responseCode: String by lazy {
            @OptIn(kotlinx.serialization.ExperimentalSerializationApi::class)
            serializer().descriptor.serialName
        }
    }

    class Failed(val errorDescription: String) : UnregisterAllResponse()
    class Error(val exception: Throwable) : UnregisterAllResponse()
    class Timeout(val exception: Throwable) : UnregisterAllResponse()

    fun <R> fold(
        onInvalid: (Invalid: Invalid) -> R,
        onUnregistrationSuccess: (UnregistrationSuccess: UnregistrationSuccess) -> R,
        onNoDevicesToUnregister: (NoDevicesToUnregister: NoDevicesToUnregister) -> R,
        onFailed: (Failed: Failed) -> R,
        onError: (Error: Error) -> R,
        onTimeout: (Timeout: Timeout) -> R
    ): R {
        return when (this) {
            is Invalid -> onInvalid(Invalid(this.message, this.responseCode))
            is UnregistrationSuccess -> onUnregistrationSuccess(UnregistrationSuccess())
            is NoDevicesToUnregister -> onNoDevicesToUnregister(NoDevicesToUnregister())
            is Failed -> onFailed(Failed(this.errorDescription))
            is Error -> onError(Error(this.exception))
            is Timeout -> onTimeout(Timeout(this.exception))
        }
    }
}